import { render } from "./AlzataDatePicker.vue?vue&type=template&id=20c20bb3"
import script from "./AlzataDatePicker.vue?vue&type=script&lang=js"
export * from "./AlzataDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__